import { useState, useEffect } from 'react';

interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  user?: {
    email: string;
    name: string;
  };
}

export function useAuth(): AuthState {
  const [state, setState] = useState<AuthState>({
    isAuthenticated: false,
    isLoading: true,
  });

  useEffect(() => {
    // Check Cloudflare Access headers
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      // In production, this would check Cloudflare Access JWT
      // For now, we'll simulate authentication
      const response = await fetch('/api/auth/me');
      if (response.ok) {
        const user = await response.json();
        setState({
          isAuthenticated: true,
          isLoading: false,
          user,
        });
      } else {
        setState({
          isAuthenticated: false,
          isLoading: false,
        });
      }
    } catch (error) {
      // In development, assume authenticated
      setState({
        isAuthenticated: true,
        isLoading: false,
        user: {
          email: 'dev@fanworld.gg',
          name: 'Developer',
        },
      });
    }
  };

  return state;
}